import React from 'react';

import { ReactComponent as NoResults } from '@assets/svg/no-results.svg';

import style from './style.module.scss';

interface IProps {
  mainText?: string;
  extraText?: string;
}

const EmptyFilterBlock: React.FC<IProps> = ({ mainText, extraText }) => {
  return (
    <div className={style.emptyBlock}>
      <NoResults className={style.noResultsIcon} />
      {mainText && <div className={style.mainText}>{mainText}</div>}
      {extraText && <div className={style.extraText}>{extraText}</div>}
    </div>
  );
};

export default EmptyFilterBlock;
